import api from "@/Library/api.js";
import method from "@/Library/method.js";
let apiresult;
let controller;
let action;
let url;

export default {

    /** 获取教程分类信息 **/
    GET_CATE_LIST(data) {
        controller='Platvedio';
        action='GetCateList';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取教程一级分类信息 **/
    GET_CATE_PARENT(data) {
        controller='Platvedio';
        action='GetCateParent';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取教程所有分类信息 **/
    GET_CATE_All(data) {
        controller='Platvedio';
        action='GetCateAll';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 新增分类信息 **/
    ADD_CATE(data) {
        controller='Platvedio';
        action='AddCates';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 修改分类信息 **/
    Edit_CATE(data) {
        controller='Platvedio';
        action='EditCates';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 修改分类排序 **/
    Edit_CATE_SORT(data) {
        controller='Platvedio';
        action='EditCatesSort';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取分类信息详情 **/
    GET_CATE_INFO(data) {
        controller='Platvedio';
        action='GetCateInfo';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 删除分类信息 **/
    DEL_CATE_INFO(data) {
        controller='Platvedio';
        action='DelCateinfos';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },


    //////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////
    //教程数据


    /** 获取视频信息列表 **/
    GET_TUTORIALS_LIST(data) {
        controller='Platvedio';
        action='GetTutorialsList';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },


    /** 新增视频信息 **/
    ADD_TUTORIALS(data) {
        controller='Platvedio';
        action='AddTutorials';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },


    /** 编辑视频信息 **/
    EDIT_TUTORIALS(data) {
        controller='Platvedio';
        action='EditTutorials';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },


    /** 获取教程信息详情 **/
    GET_TUTORIALS_INFO(data) {
        controller='Platvedio';
        action='GETTutorialsInfos';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },


    /** 删除教程 **/
    DEL_TUTORIALS(data) {
        controller='Platvedio';
        action='DelTutorials';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },


    /** 修改教程排序方式 **/
    DEL_TUTORIALS_SORT(data) {
        controller='Platvedio';
        action='ChangeTutorialsSort';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

}